/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Modifiedutc3Inputs */

const en_entity_modifiedutc3 = /** @type {(inputs: Entity_Modifiedutc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modified (UTC)`)
};

const de_entity_modifiedutc3 = /** @type {(inputs: Entity_Modifiedutc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geändert (UTC)`)
};

/**
* | output |
* | --- |
* | "Modified (UTC)" |
*
* @param {Entity_Modifiedutc3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_modifiedutc3 = /** @type {((inputs?: Entity_Modifiedutc3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Modifiedutc3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_modifiedutc3(inputs)
	return de_entity_modifiedutc3(inputs)
});
export { entity_modifiedutc3 as "entity_modifiedUTC" }